import { useParams, useLocation, Navigate } from 'react-router-dom'

// iOS shares founder-ask links as /discuss/:askId. Redirect to the canonical
// web thread route so those links don't dead-end on the catch-all.
export function DiscussRedirect() {
  const { askId } = useParams<{ askId: string }>()
  // Keep the query string so email tracking params (utm_*, eid) survive the redirect
  const { search } = useLocation()
  if (!askId) return <Navigate to={`/discussions${search}`} replace />
  return <Navigate to={`/discussions/founder_ask/${askId}${search}`} replace />
}
